import emailTemplates from './templates'

export default {
  ...emailTemplates,
}
